export { StudentAssessmentsPage } from "./StudentAssessmentsPage"
export type { StudentAssessmentsPageProps, StudentAssessmentFormProps } from "./StudentAssessmentsPage"
